import { Component } from 'react';
import PropTypes from 'prop-types';
import withFlattenedProps from '../../../decorators/form/withFlattenedProps';
import styleGuide from '../../../styles/styleGuide';
import css from './select.module.scss';

class Select extends Component {
  static propTypes = {
    id: PropTypes.string,
    dataTestId: PropTypes.string,
    name: PropTypes.string.isRequired,
    onBlur: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    tabIndex: PropTypes.number,
    disabled: PropTypes.bool,
    formFieldMeta: PropTypes.object,
    style: PropTypes.object,
    options: PropTypes.array,
    defaultOptionName: PropTypes.string,
  };

  state = {
    className: this.props.defaultOptionName ? css.selectHintOption : css.select,
  };

  onChange = (event) => {
    this.setSelectClassName(event.target.value);

    this.props.onChange(event);
  };

  onFocus = (event) => {
    if (!this.props.disabled) {
      this.props.onFocus(event);
    }
  };

  // Workaround Chrome's insistence on enforcing it's browser defaults over what we define.  If the
  // first option has no value (denoting a `hint`), we want to show a different color.  We can only
  // do that in Chrome by setting the select class name itself.
  setSelectClassName = (value) => {
    if (value) {
      this.setState({ className: css.select });
    } else {
      this.setState({ className: css.selectHintOption });
    }
  };

  render() {
    const {
      id,
      dataTestId,
      name,
      formFieldMeta,
      style,
      tabIndex,
      disabled,
      options,
      defaultOptionName,
      onBlur,
    } = this.props;

    const { className } = this.state;
    const showErrorState =
      formFieldMeta && formFieldMeta.touched && formFieldMeta.invalid;

    const finalStyle = !disabled
      ? style
      : {
          ...style,
          ...styleGuide.disabledState,
        };

    return (
      <div>
        <select
          className={className}
          style={finalStyle}
          id={id}
          data-testid={dataTestId}
          name={name}
          onFocus={this.onFocus}
          onBlur={onBlur}
          onChange={this.onChange}
          tabIndex={tabIndex}
          disabled={disabled}
          data-error={showErrorState}
        >
          {defaultOptionName && (
            <option key="default" className={css.defaultOption} value="">
              {defaultOptionName}
            </option>
          )}
          {options &&
            options.map((option) => (
              <option
                className={css.option}
                key={option.value}
                value={option.value}
              >
                {option.name}
              </option>
            ))}
        </select>
        {showErrorState && (
          <div style={styleGuide.inlineError}>{formFieldMeta.error}</div>
        )}
      </div>
    );
  }
}

export default withFlattenedProps(Select);
